const processInclude = require('app_storefront_base/util');
const storeCarousel = require('plugin_store_locator/components/store-carousel');

window.onjQueryLoad(function () {
    processInclude(require('plugin_store_locator/global'));
    storeCarousel.init();
}, true);
